import svgJS from "svgjs";

export default {
  install: Vue => {
    Vue.prototype.$svg = svgJS;
  }
};



// WEBPACK FOOTER //
// ./src/plugin/vueSvgPlugin.js